import styled, { createGlobalStyle } from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .admin-applications-page {
    .applications-area {
      padding: 70px 0;

      .card-box {
        background: #fff;
        border: 1px solid ${colors.border1};
        border-radius: 6px;
        box-shadow: 0 0 25px rgba(0, 0, 0, 0.08);
        padding: 30px;
      }

      .filter-bar {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 15px;

        form {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          input {
            flex: 1;
            min-width: 220px;
            border: 1px solid ${colors.border3};
            border-radius: 4px;
            padding: 10px 12px;
            font-size: 14px;
          }

          button {
            padding: 10px 18px;
            border-radius: 4px;
            border: none;
            font-size: 14px;
            font-weight: 600;
            text-transform: uppercase;
            background: ${colors.red_bg};
            color: #fff;
            cursor: pointer;
            transition: background 0.2s ease;
            &:hover {
              background: ${colors.red_bg2};
            }
            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
              background: ${colors.border3};
              color: ${colors.text3};
            }
          }

          .clear-btn {
            background: transparent;
            color: ${colors.text3};
            border: 1px solid ${colors.border3};
            &:hover {
              color: #fff;
              background: ${colors.red};
              border-color: ${colors.red};
            }
            &:disabled {
              background: transparent;
              color: ${colors.text3};
              border-color: ${colors.border3};
            }
          }
        }

        .active-filter {
          font-size: 14px;
          color: ${colors.text3};
        }

        .filter-controls {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;

          .control {
            display: flex;
            flex-direction: column;
            gap: 6px;
            min-width: 180px;

            select,
            input {
              border: 1px solid ${colors.border3};
              border-radius: 4px;
              padding: 10px 12px;
              font-size: 14px;
              background: #fff;
              color: ${colors.text1};
              min-width: 180px;
            }

            .filter-feedback {
              font-size: 12px;
              color: ${colors.text3};

              &.error {
                color: ${colors.red};
              }
            }
          }
        }
      }

      .link-button {
        background: transparent;
        border: none;
        color: ${colors.red};
        text-decoration: underline;
        cursor: pointer;
        padding: 0;
        font-size: 14px;
        font-weight: 600;
        &:hover {
          color: ${colors.red2};
        }
        &:disabled {
          color: ${colors.text3};
          cursor: not-allowed;
          text-decoration: none;
        }
      }

      .icon-button {
        background: transparent;
        border: none;
        color: ${colors.black1};
        cursor: pointer;
        padding: 6px;
        font-size: 18px;
        line-height: 1;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: color 0.2s ease, transform 0.2s ease;

        &:hover {
          color: ${colors.black2};
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
        }

        &:disabled {
          color: ${colors.text3};
          cursor: not-allowed;
          transform: none;
        }

        i {
          pointer-events: none;
        }
      }

      .data-grid {
        margin-top: 20px;

        table {
          width: 100%;
          border-collapse: collapse;
          th,
          td {
            padding: 12px 14px;
            border: 1px solid ${colors.border3};
            vertical-align: middle;
            font-size: 14px;
          }

          th {
            background: ${colors.red_bg};
            color: #fff;
            text-transform: uppercase;
            font-weight: 600;
          }

          tbody tr:nth-child(odd) {
            background: #fafafa;
          }

          tbody tr:hover {
            background: rgba(0, 0, 0, 0.03);
          }
        }

        .muted {
          color: ${colors.text3};
        }

        .latest-note {
          display: flex;
          flex-direction: column;
          gap: 4px;

          time {
            font-size: 12px;
            color: ${colors.text3};
          }
        }

        .pagination-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          gap: 15px;
          flex-wrap: wrap;

          .page-info {
            font-size: 14px;
            color: ${colors.text3};
          }

          .page-actions {
            display: flex;
            align-items: center;
            gap: 10px;

            button {
              padding: 8px 16px;
              border-radius: 4px;
              border: 1px solid ${colors.border3};
              background: ${colors.red_bg};
              color: #fff;
              font-size: 14px;
              font-weight: 600;
              transition: background 0.2s ease;
              &:hover {
                background: ${colors.red_bg2};
              }
              &:disabled {
                opacity: 0.55;
                cursor: not-allowed;
                background: ${colors.border3};
                color: ${colors.text3};
              }
            }

            select {
              border: 1px solid ${colors.border3};
              border-radius: 4px;
              padding: 8px 12px;
              font-size: 14px;
            }
          }
        }
      }

      .actions {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 15px;
      }

      .action-buttons {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
      }
    }

    @media (max-width: 767px) {
      .applications-area {
        padding: 40px 0;

        .card-box {
          padding: 20px;
        }

        .data-grid {
          overflow-x: auto;
        }
      }
    }
  }
`;

export const AdminModalStyles = createGlobalStyle`
    .admin-applications-modal .note-history {
        margin-top: 20px;

        h6 {
            font-size: 15px;
            font-weight: 600;
            margin-bottom: 10px;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                padding: 8px 12px;
                border: 1px solid ${colors.border3};
                border-radius: 5px;
                margin-bottom: 8px;
                background: #fafafa;

                small {
                    display: block;
                    margin-top: 4px;
                    color: ${colors.text3};
                    font-size: 12px;
                }
            }
        }
    }

    .admin-applications-modal.profile-modal {
        .modal-content {
            border-radius: 10px;
            border: none;
            box-shadow: 0 20px 60px rgba(0,0,0,0.18);
        }

        .modal-header {
            border-bottom: 1px solid ${colors.border1};
            padding: 20px 24px;
            h5 {
                font-size: 18px;
                font-weight: 600;
                color: ${colors.black1};
            }
        }

        .modal-body {
            padding: 24px;
            background: ${colors.bg2};
        }

        .profile-details {
            display: flex;
            flex-direction: column;
            gap: 20px;

            .profile-grid {
                margin: 0;
                > .profile-section {
                    background: #fff;
                    border: 1px solid ${colors.border1};
                    border-radius: 8px;
                    padding: 20px;
                    box-shadow: 0 12px 25px rgba(0,0,0,0.05);
                    margin-bottom: 20px;

                    .section-heading {
                        font-size: 16px;
                        font-weight: 600;
                        color: ${colors.black1};
                        margin-bottom: 12px;
                        position: relative;
                        padding-bottom: 8px;

                        &:after {
                            content: "";
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            width: 40px;
                            height: 3px;
                            background: ${colors.red};
                        }
                    }

                    .profile-meta {
                        li {
                            display: flex;
                            justify-content: space-between;
                            gap: 15px;
                            padding: 6px 0;
                            border-bottom: 1px solid ${colors.border2};
                            font-size: 14px;
                            color: ${colors.text1};

                            &:last-child {
                                border-bottom: none;
                            }

                            strong {
                                color: ${colors.black1};
                                width: 45%;
                                flex-shrink: 0;
                            }

                            @media (max-width: 575px) {
                                flex-direction: column;
                                strong {
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }
        }

        .modal-footer {
            border-top: 1px solid ${colors.border1};
            padding: 16px 24px;
        }
    }

    .admin-applications-modal.notes-modal {
        .modal-content {
            border-radius: 10px;
            border: none;
            box-shadow: 0 18px 45px rgba(0,0,0,0.15);
        }

        .modal-header {
            border-bottom: 1px solid ${colors.border1};
            padding: 20px 24px;

            h5 {
                font-size: 18px;
                font-weight: 600;
                color: ${colors.black1};
            }
        }

        .modal-body {
            padding: 24px;
            background: ${colors.bg2};

            h5 {
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 6px;
            }

            .meta {
                font-size: 13px;
                color: ${colors.text3};
                margin-bottom: 16px;
            }

            .notes-list {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                flex-direction: column;
                gap: 10px;

                li {
                    background: #fff;
                    border: 1px solid ${colors.border2};
                    border-radius: 6px;
                    padding: 12px 14px;
                    box-shadow: 0 6px 18px rgba(0,0,0,0.05);

                    p {
                        margin: 0;
                        font-size: 14px;
                        color: ${colors.text1};
                    }

                    small {
                        display: block;
                        margin-top: 6px;
                        font-size: 12px;
                        color: ${colors.text3};
                    }
                }
            }

            .muted {
                color: ${colors.text3};
            }
        }

        .modal-footer {
            border-top: 1px solid ${colors.border1};
            padding: 16px 24px;
        }
    }
`;
